import httpService from '@/services/httpService'
import { convertAdvancedOptionsToURLParams } from '@/store/modules/rank-zone/Helper'
import _ from 'lodash'

export const types = {
  ADD_KEYWORDS_MOVEMENT_ITEM: 'rank-zone/ADD_KEYWORDS_MOVEMENT_ITEM',
  RESET_KEYWORDS_ITEM: 'rank-zone/RESET_KEYWORDS_ITEM'
}

// Headers of table columns
const emptyTable = [
  {
    label: '01 - 03',
    propName: '01 - 03',
    filterName: 'commaDividedNumber',
    children: [],
    keywords: 0,
    msv: 0
  },
  {
    label: '04 - 07',
    propName: '04 - 07',
    filterName: 'commaDividedNumber',
    children: [],
    keywords: 0,
    msv: 0
  },
  {
    label: '08 - 10',
    propName: '08 - 10',
    filterName: 'commaDividedNumber',
    children: [],
    keywords: 0,
    msv: 0
  },
  {
    label: '11 - 25',
    propName: '11 - 25',
    filterName: 'commaDividedNumber',
    children: [],
    keywords: 0,
    msv: 0
  },
  {
    label: '26 - 50',
    propName: '26 - 50',
    filterName: 'commaDividedNumber',
    children: [],
    keywords: 0,
    msv: 0
  },
  {
    label: '51 - 100',
    propName: '51 - 100',
    filterName: 'commaDividedNumber',
    children: [],
    keywords: 0,
    msv: 0
  },
  {
    label: 'NR',
    propName: 'NR',
    filterName: 'commaDividedNumber',
    children: [],
    keywords: 0,
    msv: 0
  },
  {
    label: 'ND',
    propName: 'ND',
    filterName: 'commaDividedNumber',
    children: [],
    keywords: 0,
    msv: 0
  }
]
const state = {
  tableData: emptyTable,
  total: {},
  // keywords for export in progress tab
  keywords: []
}

const mutations = {
  [types.ADD_KEYWORDS_MOVEMENT_ITEM]: function (state, keywords) {
    if (!keywords || !keywords.length) {
      state.tableData = emptyTable
    }
    const newTableData = _.cloneDeep(emptyTable)
    // first action here - we should spread received data throughout all columns
    for (const item of keywords) {
      for (let cell of newTableData) {
        const msv = item[cell.propName]
        if(!msv){
          continue
        }
        cell.children.push({
          label: item.label,
          msv,
          keywords: 1
        })
      }
    }
    const total = { msv: 0, keywords: 0 }
    // second action - calculate total kw and msv for each column based on child data
    for (const cell of newTableData) {
      for (const item of cell.children) {
        cell.msv += item.msv
        cell.keywords += 1
      }
      total.msv += cell.msv
      total.keywords += cell.keywords
    }
    state.tableData = newTableData
    state.total = total
    state.keywords = keywords
  },
  [types.RESET_KEYWORDS_ITEM]: function (state) {
    state.tableData = emptyTable
    state.total = {}
    state.keywords = []
  }
}
const actions = {
  async getKeywordsMovement ({ commit }, { clientId, ...params }) {
    const msv = JSON.parse(localStorage.getItem('msv')) || {}
    params.msv = msv[clientId] || 1
    const response = await httpService.get(`/reports/rankzone-report/keyword_movement/${clientId}`, { params })
    if (response && response.data) {
      commit(types.ADD_KEYWORDS_MOVEMENT_ITEM, response.data.keywords)
    }
  },
  async getKeywordsMovementProgress ({ commit }, { clientId, ...rest }) {
    const msv = JSON.parse(localStorage.getItem('msv')) || {}
    rest.msv = msv[clientId] || 1
    const params = convertAdvancedOptionsToURLParams(rest)
    const response = await httpService.get(`/reports/rankzone-report/keyword_movement_progress/${clientId}`, { params })
    if (response && response.data) {
      commit(types.ADD_KEYWORDS_MOVEMENT_ITEM, response.data.keywords)
    }
  },
  async getSnapshot ({ commit }, { clientId, ...rest }) {
    const msv = JSON.parse(localStorage.getItem('msv')) || {}
    rest.msv = msv[clientId] || 1
    const params = convertAdvancedOptionsToURLParams(rest)
    const response = await httpService.get(`/reports/rankzone-report/keyword_movement_snapshot/${clientId}`, { params })
    if (response && response.data) {
      commit(types.ADD_KEYWORDS_MOVEMENT_ITEM, response.data.keywords)
    }
  },
  resetKeywordsMovement ({ commit }) {
    commit(types.RESET_KEYWORDS_ITEM)
  }
}

/**
 * Store keep table data and has column's header's as a default. Used in KeywordMovementTable.vue
 */
export default {
  namespaced: true,
  state,
  actions,
  mutations
}
